import { css } from 'twind/css'

export const appointmentLobbyContainer = (isMobileWebEnabled: boolean) =>
  css({
    background: 'var(--gray-10)',
    borderRadius: !isMobileWebEnabled ? 'var(--border-radius-md)' : 'none',
  })

export const appointmentLobbyLegalStatement = css({
  color: 'var(--gray-8)',
  fontSize: 'var(--font-size-xxs)',
  '& a': {
    textDecoration: 'underline',
  },
})
